import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import clsx from "clsx";
import styles from "./CartPage.module.scss";
import { currencyFormat } from "../../../utils/currencyFormat";
import { tariffGetList } from "../../../redux/actions/tariff/tariffGetList";
import TariffCart from "../../../components/site/TariffCart/TariffCart";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { calculateReferralPrice } from "../../../redux/actions/referral/calculateReferralPrice";
import Loading from "../../../components/site/Loading/Loading";
import { useSearchParams } from "react-router-dom";
import { tariffPayment } from "../../../redux/actions/tariff/tariffPayment";
import { resetTariffPayment } from "../../../redux/slices/tariff.slice";
import { useMediaQuery } from "../../../utils/useMediaQuery";
// import MaintenanceModal from "../../../components/site/common/MaintenanceModal/MaintenanceModal";

export function percentage(price, discount) {
  var numVal1 = parseInt(price);
  var numVal2 = parseInt(discount) / 100;

  var totalValue = numVal1 - numVal1 * numVal2;
  return totalValue.toFixed(0);
}
export function percentageValue(price, discount) {
  var numVal1 = parseInt(price);
  var numVal2 = parseInt(discount) / 100;

  return numVal1 * numVal2;
}

const CartPage = () => {
  const form = useForm();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width: 576px)");
  const [searchParams, setSearchParams] = useSearchParams();

  const [activeTariff, setActiveTariff] = useState(false);
  const {
    tariffGetList: { data: tariffList },
    tariffPayment: {
      data: tariffPaymentData,
      loading: tariffPaymentLoading,
      error: tariffPaymentError,
    },
  } = useSelector((state) => state.tariff);
  const {
    userProfile: { data: userProfile },
  } = useSelector((state) => state.user);
  const {
    calculateReferralPrice: {
      data: referralPriceData,
      loading: referralPriceLoading,
    },
  } = useSelector((state) => state.referral);

  useEffect(() => {
    if (tariffPaymentData?.payment_link && !tariffPaymentError) {
      window.location.href = tariffPaymentData?.payment_link;
    }
  }, [tariffPaymentData, tariffPaymentError]);
  useEffect(() => {
    return () => {
      dispatch(resetTariffPayment());
    };
  }, []);
  const navigate = useNavigate();
  // const [showMaintenanceModal, setShowMaintenanceModal] = useState(false);
  useEffect(() => {
    if (tariffPaymentData && tariffPaymentError) {
      if (
        tariffPaymentData.error ===
        "Please link your Telegram account to your profile in order to make a payment."
      ) {
        toast.error(
          <>
            <div
              style={{
                display: "inline-block",
                textDecoration: "underline",
                textDecorationThickness: "1px",
                textUnderlineOffset: "2px",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/account/edit");
              }}
            >
              Войдите через телеграм
            </div>
            , чтобы купить тариф{" "}
          </>
        );
      }
    }
  }, [tariffPaymentError, tariffPaymentData]);

  useEffect(() => {
    if (tariffList) {
      let tariffIndex = 0;
      if (searchParams.get("tariff")) {
        tariffIndex = tariffList.findIndex(
          (tariff) => tariff?.id == searchParams.get("tariff")
        );
      }
      setActiveTariff({
        id: tariffList[tariffIndex].id,
        name: tariffList[tariffIndex].name,
        price: tariffList[tariffIndex].price,
        duration: tariffList[tariffIndex].duration,
      });
    }
  }, [tariffList]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(tariffGetList());
  }, []);

  useEffect(() => {
    if (activeTariff?.price) {
      dispatch(calculateReferralPrice(activeTariff?.price));
    }
  }, [activeTariff]);

  // Helper function to get period value for navigation
  const getPeriodValue = (duration) => {
    switch (duration) {
      case 1:
        return "1_month";
      case 3:
        return "3_months";
      case 6:
        return "6_months";
      case 12:
        return "12_months";
      default:
        return "1_month";
    }
  };

  return (
    <>
      <div class="dm-page-content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="breadcrumb-main">
                <h4 class="text-capitalize breadcrumb-title">
                  Оформление подписки
                </h4>
              </div>
            </div>
            <div class="col-12 col-lg-8">
              <div class="card card-default card-md mb-4">
                <div class="card-body p-20 p-md-30">
                  {/* Tariffs Grid */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr)",
                      gap: "20px 10px",
                    }}
                  >
                    {tariffList?.map((item, index) => (
                      <TariffCart
                        key={item.id}
                        period={getPeriodValue(item.duration)}
                        {...item}
                        color={item?.color ?? "primary"}
                        price={item?.price}
                        active={activeTariff?.id == item?.id}
                        setActive={setActiveTariff}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>{" "}
            <div class="col-12 col-lg-4">
              <div
                class=" order-summery"
                style={{ position: "sticky", top: "84px" }}
              >
                <div class="card-body px-sm-25 px-20 pt-20">
                  <div
                    className="pb-10 mb-10 "
                    style={{ borderBottom: "1px solid var(--border-color)" }}
                  >
                    <h4 className="mb-20 card-bordered">Ваша подписка</h4>
                    <div class="total">
                      <div class="subtotalTotal">
                        {activeTariff?.name}
                        <span>
                          {referralPriceData?.has_discount ? (
                            <>
                              <span
                                style={{
                                  textDecoration: "line-through",
                                  color: "var(--color-lighten)",
                                }}
                              >
                                {currencyFormat(
                                  referralPriceData.original_price
                                )}
                              </span>
                              <span style={{ marginLeft: "8px" }}>
                                {currencyFormat(referralPriceData.final_price)}
                              </span>
                            </>
                          ) : (
                            currencyFormat(
                              referralPriceData?.final_price ||
                                activeTariff?.price
                            )
                          )}{" "}
                        </span>
                      </div>
                      {referralPriceData?.has_discount && (
                        <div class="subtotalTotal">
                          Скидка по реферальной программе
                          <span>
                            --
                            {currencyFormat(
                              referralPriceData.discount_amount
                            )}{" "}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div class="total-money d-flex justify-content-between mt-50 align-items-end">
                    <h6>Итого:</h6>
                    <h3 style={{ color: "var(--color-dark)" }}>
                      {referralPriceData?.has_discount
                        ? currencyFormat(referralPriceData.final_price)
                        : currencyFormat(activeTariff?.price || 0)}{" "}
                    </h3>
                  </div>
                  <a
                    onClick={() => {
                      dispatch(
                        tariffPayment({
                          tariff_id: activeTariff.id,
                          new_subscription:
                            userProfile?.tariff_info?.id == activeTariff.id
                              ? "false"
                              : "true",
                        })
                      );
                    }}
                    // onClick={(e) => { e.preventDefault(); setShowMaintenanceModal(true); }}
                    href="#"
                    class="checkout btn-success content-center w-100 btn-lg mt-20"
                  >
                    {" "}
                    Оплатить{" "}
                    {referralPriceData?.has_discount
                      ? currencyFormat(referralPriceData.final_price)
                      : currencyFormat(activeTariff?.price || 0)}{" "}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {(tariffPaymentLoading || referralPriceLoading) && <Loading />}
      </div>
      {/* {showMaintenanceModal && <MaintenanceModal onClose={() => setShowMaintenanceModal(false)} />} */}
    </>
  );
};

export default CartPage;
